import {CommonModule, CurrencyPipe} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSortModule} from '@angular/material/sort';
import {MatTabsModule} from '@angular/material/tabs';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatTreeModule} from '@angular/material/tree';
import {DisplayEditFieldModule} from '../components/display-edit-field/display-edit-field.module';
import {MaterialModule} from '../material.module';
import {CategorySortPipe} from './category-sort/category-sort.pipe';
import {TtdCategoryCreateComponent} from './ttd-category-config/create/ttd-category-create.component';
import {TtdCategoryConfigComponent} from './ttd-category-config/ttd-category-config.component';
import {TtdPartnerCreateComponent} from './ttd-partner-config/create/ttd-partner-create.component';
import {TtdPartnerConfigComponent} from './ttd-partner-config/ttd-partner-config.component';
import {TtdComponent} from './ttd.component';
import {TtdRoutingModule} from './ttd.routes';
import {
  TtdPartnerGroupCreateComponent
} from './ttd-partner-config/partner-group-create/ttd-partner-group-create.component';
import {SharedModule} from '../shared.module';
import {AcknowledgeOverlayModule} from '../components/acknowledge-overlay/acknowledge-overlay.module';
import {MatCardModule} from '@angular/material/card';
import { TtdCategoryContentComponent } from './ttd-category-config/ttd-category-content/ttd-category-content.component';
import { TtdBrandSelectorComponent } from './ttd-category-config/ttd-brand-selector/ttd-brand-selector.component';

@NgModule({
  declarations: [
    TtdComponent,
    TtdPartnerConfigComponent,
    TtdPartnerCreateComponent,
    TtdCategoryConfigComponent,
    TtdCategoryCreateComponent,
    CategorySortPipe,
    TtdPartnerGroupCreateComponent,
    TtdCategoryContentComponent,
    TtdBrandSelectorComponent,
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    TtdRoutingModule,
    MaterialModule,
    MatTreeModule,
    MatButtonToggleModule,
    MatTabsModule,
    MatSortModule,
    MatTooltipModule,
    MatCardModule,
    MatProgressSpinnerModule,
    DisplayEditFieldModule,
    SharedModule,
    AcknowledgeOverlayModule
  ],
  exports: [
    TtdBrandSelectorComponent
  ],
  providers: [CurrencyPipe]
})
export class TtdModule {
}
